/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PrioritizedClientCaseDefinition {
  None = 'None',
  CurrentAppointment = 'CurrentAppointment',
  Unpaid = 'Unpaid',
  NewMessages = 'NewMessages',
  NewMessagesDifferentCases = 'NewMessagesDifferentCases',
  UnansweredForms = 'UnansweredForms',
  UpcomingAppointment = 'UpcomingAppointment'
}
